//#region Imports
import { createSingleEventEmitter } from "@anydo/core";
//#endregion

type OpT = () => Promise<any>;

export class AuthReactAdapterExectutionBlockQueue {
  private _ops: Array<OpT> = [];
  private _isPending = false;

  //#region Private
  private _emptyQueue() {
    this._ops = [];
    this._isPending = false;
  }

  private async _runQueue() {
    if (this._isPending) return;

    this._isPending = true;

    let op: OpT | undefined;

    while ((op = this._ops.shift())) {
      try {
        await op();
      } catch (error: any) {
        try {
          this._errorEmitter.emit(error);
        } finally {
          this._isPending = false;
          this._emptyQueue();
          // eslint-disable-next-line no-unsafe-finally
          return;
        }
      }
    }

    this._isPending = false;
    this._queueFinishEmitter.emit();
  }
  //#endregion

  //#region Public - Listener
  private _errorEmitter = createSingleEventEmitter<Error>();
  private _queueFinishEmitter = createSingleEventEmitter();

  onError = this._errorEmitter.on;
  onQueueFinish = this._queueFinishEmitter.on;
  //#endregion

  //#region Public - setup
  destroy() {
    this._isPending = true;
    this._ops = [];
    this._errorEmitter.off();
    this._queueFinishEmitter.off();
  }
  //#endregion

  //#region Public
  isPending(): boolean {
    return this._isPending;
  }

  addOp(op: OpT) {
    this._ops.push(op);
    this._runQueue();
  }

  addOpIfEmpty(op: OpT) {
    if (!this.isPending()) {
      this.addOp(op);
    }
  }
  //#endregion
}
